// extracted by mini-css-extract-plugin
export default {"summaryTitle":"FormTableTotal_summaryTitle__gMs1O","summaryTitleDisabled":"FormTableTotal_summaryTitleDisabled__RyZfH","totalSumInput":"FormTableTotal_totalSumInput__4Fjfg"};